import { render, staticRenderFns } from "./ContentInfoModule.vue?vue&type=template&id=a73481d4&scoped=true"
import script from "./ContentInfoModule.vue?vue&type=script&lang=js"
export * from "./ContentInfoModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73481d4",
  null
  
)

export default component.exports